import api from './api';

/** Bewertungen am Marktplatz-Angebot (Marktplatz-Rework T9, `/api/marketplace/*review*`). */

export interface MarketplaceReview {
    id: number;
    listingId: number | null;
    licenseId: number | null;
    rating: number;
    title: string | null;
    body: string | null;
    reviewerName: string | null;
    /** Bewertung des eigenen Mandanten */
    mine: boolean;
    status: 'approved' | 'hidden';
    sellerReply: string | null;
    sellerReplyAt: string | null;
    createdAt: string;
    updatedAt: string;
}

export interface ReviewSummary {
    count: number;
    average: string | null;
}

export interface ReviewInput {
    rating: number;
    title?: string;
    body?: string;
}

export const marketplaceReviewService = {
    async getListingReviews(listingId: number): Promise<{ summary: ReviewSummary; reviews: MarketplaceReview[] }> {
        const { data } = await api.get(`/marketplace/listings/${listingId}/reviews`);
        return { summary: data.summary ?? { count: 0, average: null }, reviews: data.reviews ?? [] };
    },
    /** Eigene Bewertungen des Mandanten, nach Lizenz-ID. */
    async getMyReviews(): Promise<Record<number, MarketplaceReview>> {
        const { data } = await api.get('/marketplace/reviews/mine');
        const byLicense = data?.reviews;

        return byLicense && !Array.isArray(byLicense) ? byLicense : {};
    },
    async create(licenseId: number, input: ReviewInput): Promise<MarketplaceReview> {
        const { data } = await api.post(`/marketplace/licenses/${licenseId}/review`, input);
        return data.review;
    },
    async update(licenseId: number, input: ReviewInput): Promise<MarketplaceReview> {
        const { data } = await api.put(`/marketplace/licenses/${licenseId}/review`, input);
        return data.review;
    },
    /** Leerer Text entfernt die Antwort. */
    async reply(reviewId: number, reply: string): Promise<MarketplaceReview> {
        const { data } = await api.post(`/marketplace/reviews/${reviewId}/reply`, { reply });
        return data.review;
    },
};

export default marketplaceReviewService;
